import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider';
import { App } from './App';
import { ToastProvider } from './components/Toast';
import { I18nProvider } from './lib/i18n';
import './styles/tokens.css';
import './styles/base.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // البيانات تُعتبر طازجة نصف دقيقة: يمنع ذلك إعادة الجلب عند كل تنقّل.
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // أخطاء الصلاحيات لا تُعاد محاولتها: النتيجة لن تتغير بالتكرار.
      retry: (count, error) => {
        const status = (error as { status?: number }).status;
        if (status === 401 || status === 403 || status === 404) return false;
        return count < 2;
      },
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <I18nProvider>
        <AuthProvider>
          {/*
            مزوّد التأكيدات حول التطبيق كله: الإجراءات تقع في شاشات متفرقة،
            والرسالة تُرسَم في `body` عبر بوّابة فلا يقصّها شيء.
          */}
          <ToastProvider>
            <App />
          </ToastProvider>
        </AuthProvider>
        </I18nProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
